import { axiosAPI } from 'utils';

export default {
  getCopyAudit(params) {
    return axiosAPI
      .get(`api/admin/strings/copy-audit`, { params })
      .then((res) => res.data)
      .catch((err) => {
        console.error(err);
        return err.response?.data || { success: false, _error: err.message };
      });
  },

  cleanupCopyMarkers(payload) {
    return axiosAPI
      .post(`api/admin/strings/copy-cleanup`, payload)
      .then((res) => res.data)
      .catch((err) => {
        console.error(err);
        return err.response?.data || { success: false, _error: err.message };
      });
  },

  getCopyCleanupExportPage(params) {
    return axiosAPI
      .get(`api/admin/strings/copy-cleanup-export-page`, { params })
      .then((res) => res.data)
      .catch((err) => {
        console.error(err);
        return err.response?.data || { success: false, _error: err.message };
      });
  },

  cleanupCopyMarkerOne(payload) {
    return axiosAPI
      .post(`api/admin/strings/copy-cleanup-one`, payload)
      .then((res) => res.data)
      .catch((err) => {
        console.error(err);
        return err.response?.data || { success: false, _error: err.message };
      });
  },


  exportCopyCleanupCsv(params) {
    return axiosAPI
      .get(`api/admin/strings/copy-cleanup-export`, {
        params,
        responseType: 'blob',
      });
  },


  translateStrings(payload) {
    return axiosAPI
      .post(`api/admin/strings/translate`, payload)
      .then((res) => res.data)
      .catch((err) => {
        console.error(err);
        return err.response?.data || { success: false, _error: err.message };
      });
  },

  cleanupPrettyValues(payload) {
    return axiosAPI
      .post(`api/admin/strings/pretty-value-cleanup`, payload)
      .then((res) => res.data)
      .catch((err) => {
        console.error(err);
        return err.response?.data || { success: false, _error: err.message };
      });
  },

  previewAddAudio(payload) {
    return axiosAPI
      .post(`api/admin/strings/add-audio/preview`, payload)
      .then((res) => res.data)
      .catch((err) => {
        console.error(err);
        return err.response?.data || { success: false, _error: err.message };
      });
  },

  addAudio(payload) {
    return axiosAPI
      .post(`api/admin/strings/add-audio`, payload)
      .then((res) => res.data)
      .catch((err) => {
        console.error(err);
        return err.response?.data || { success: false, _error: err.message };
      });
  },

  getDistinctValues(params) {
    return axiosAPI
      .get(`api/admin/strings/distinct-values`, { params })
      .then((res) => res.data.map(function (value) {
        return { label: value, value };
      }))
      .catch((err) => {
        console.error(err);
        return err.response.data;
      });
  },
}